import { Container, Carousel, Image } from "react-bootstrap";
import { FaStar, FaRegStar } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "./Review.css";

// Reviews grouped by language
const reviews = {
  EN: [
    {
      name: "Emily",
      stars: 5,
      comment: "The food was amazing! Will order again!",
      avatar: "https://ui-avatars.com/api/?name=Emily&background=0077B6&color=fff"
    },
    {
      name: "John",
      stars: 4,
      comment: "Very fast delivery and delicious meals!",
      avatar: "https://api.dicebear.com/7.x/bottts/svg?seed=canopy"
    },
    {
      name: "Priya",
      stars: 5,
      comment: "We had Imperial Caterer for my daughter’s birthday. Everyone loved the desserts!",
      avatar: "https://api.dicebear.com/7.x/identicon/svg?seed=celebrate"
    },
    {
      name: "Happy Customer",
      stars: 5,
      comment: "Great service and beautiful presentation. Will recommend to friends!",
      avatar: "https://api.dicebear.com/7.x/bottts/svg?seed=happy"
    },
    {
      name: "Anonymous",
      stars: 4,
      comment: "Very satisfied with the whole experience!",
      avatar: "https://api.dicebear.com/7.x/identicon/svg?seed=anon"
    }
  ],
  BM: [
    {
      name: "Amir",
      stars: 5,
      comment: "Makanan sangat sedap dan servis terbaik! Akan pesan lagi.",
      avatar: "https://ui-avatars.com/api/?name=Amir&background=28a745&color=fff"
    },
    {
      name: "Siti",
      stars: 4,
      comment: "Penghantaran tepat waktu dan makanan masih panas. Sangat puas hati!",
      avatar: "https://api.dicebear.com/7.x/bottts/svg?seed=delivery"
    },
    {
      name: "Azlan",
      stars: 5,
      comment: "Menu vegetarian sangat kreatif dan lazat. Semua tetamu suka!",
      avatar: "https://api.dicebear.com/7.x/identicon/svg?seed=vege"
    },
    {
      name: "Happy Customer",
      stars: 5,
      comment: "Servis mesra dan persembahan makanan sangat menarik. Pasti akan cadangkan kepada rakan!",
      avatar: "https://api.dicebear.com/7.x/bottts/svg?seed=happybm"
    },
    {
      name: "Tanpa Nama",
      stars: 4,
      comment: "Pengalaman yang sangat memuaskan!",
      avatar: "https://api.dicebear.com/7.x/identicon/svg?seed=anonbm"
    }
  ],
  CN: [
    {
      name: "美玲",
      stars: 5,
      comment: "菜肴新鲜美味，摆盘也很精致，非常满意！",
      avatar: "https://ui-avatars.com/api/?name=美玲&background=fbbc04&color=222"
    },
    {
      name: "伟强",
      stars: 4,
      comment: "服务很专业，送餐也很准时，下次还会再订。",
      avatar: "https://api.dicebear.com/7.x/bottts/svg?seed=chinese"
    },
    {
      name: "欣怡",
      stars: 5,
      comment: "中式菜单特别道地，家人朋友都称赞！",
      avatar: "https://api.dicebear.com/7.x/identicon/svg?seed=joy"
    },
    {
      name: "满意客户",
      stars: 5,
      comment: "服务周到，食物摆盘漂亮，会推荐给朋友！",
      avatar: "https://api.dicebear.com/7.x/bottts/svg?seed=happycn"
    },
    {
      name: "匿名",
      stars: 4,
      comment: "整体体验非常满意！",
      avatar: "https://api.dicebear.com/7.x/identicon/svg?seed=anoncn"
    }
  ]
};

const ReviewSection = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language.toUpperCase(); // e.g., "EN", "BM", "CN"
  const activeReviews = reviews[lang] || reviews.EN; // Fallback to EN if language missing

  const renderStars = (count) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        i <= count ? <FaStar key={i} className="text-warning me-1" /> : <FaRegStar key={i} className="text-warning me-1" />
      );
    }
    return stars;
  };

  return (
    <section className="reviews-section py-5" data-aos="fade-up">
      <Container className="text-center">
        <h2 className="section-title text-center mb-5 reviews-title">
          {t("reviews.title")}
          <div className="underline"></div>
        </h2>
        <Carousel controls={false} indicators={false} interval={4000} pause={false}>
          {activeReviews.map((review, idx) => (
            <Carousel.Item key={idx}>
              <div
                className="d-flex flex-column align-items-center"
                style={{ minHeight: 280 }}
              >
                <Image
                  src={review.avatar}
                  roundedCircle
                  width={100}
                  height={100}
                  className="mb-4"
                  style={{ objectFit: 'cover' }}
                  alt={review.name}
                />
                <div className="mb-2">{renderStars(review.stars)}</div>
                <p className="lead fst-italic mx-3 reviews-quote" style={{ maxWidth: '600px' }}>
                  "{review.comment}"
                </p>
                <h6 className="mt-3 review-name">— {review.name}</h6>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </section>
  );
};

export default ReviewSection;